import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

import Colours from '/shared/styled/Colours';
import { breakpointDown } from '/shared/styled/Breakpoints';

function primaryHoverStyle({ disabled, $outline, $inverted, $customColour, $dark, theme }: ButtonStyleProps) {
  if ($customColour || disabled) {
    return;
  }
  if (!$outline) {
    let background: string = Colours.greenLight2;
    if ($inverted) {
      background = Colours.white;
    }
    if ($dark) {
      background = Colours.greyDark3;
    }

    return css`
      &:hover {
        background: ${background};
        color: ${$inverted ? Colours.greyDark3 : Colours.white} !important;
      }

      &:active {
        background: ${background};
        color: ${$inverted ? Colours.greyDark3 : Colours.white};
      }
    `;
  }
}

function primaryFocusStyle({ disabled, $inverted, $outline, $dark, theme }: ButtonStyleProps) {
  if (!disabled && !$outline) {
    let background: string = Colours.greenDark3;
    if ($inverted) {
      background = Colours.white;
    }
    if ($dark) {
      background = Colours.greyDark3;
    }

    return css`
      &:focus,
      &:active {
        background: ${background};
        color: ${$inverted ? Colours.greyDark3 : Colours.white};
      }
    `;
  }
}

function isVisibleStyle({ $isVisible = true }: ButtonStyleProps) {
  if ($isVisible) {
    return css`
      visibility: visible;
    `;
  }
  return css`
    visibility: hidden;
  `;
}

function thinnerStyle({ $thinner, $outlineReplacement = false }: ButtonStyleProps) {
  if ($thinner && !$outlineReplacement) {
    return css`
      min-height: 2rem;
      padding: 0.5rem 2rem;
    `;
  }
}

export default function primaryStyle({ $primary, $inverted, $dark, theme }: ButtonStyleProps) {
  if ($primary) {
    let colour: string = Colours.white;
    if ($inverted) {
      colour = Colours.greenLight2;
    }
    return css`
      padding: 0.866666rem 1.5rem 0.866666rem;
      border-radius: 2rem;
      font-size: 0.93333rem;
      background: ${$inverted ? Colours.white : Colours.green};
      color: ${colour} !important;
      min-width: 5rem;
      min-height: 2.66666rem;
      letter-spacing: 0.05px;
      font-weight: ${theme?.target?.isConsumer ? 400 : 500};
      text-align: center;
      ${
        $inverted &&
        css`
        font-weight: 500;
      `
      }
      ${
        $dark &&
        css`
        border: 1px solid ${Colours.blackDark1};
        background: ${Colours.white};
        color: ${Colours.blackDark1} !important;
      `
      }
      ${breakpointDown('mobile')} {
        width: 100%;
      }
      ${primaryHoverStyle}
      ${primaryFocusStyle}
      ${thinnerStyle}
      ${isVisibleStyle}
    `;
  }
}
